/* Name Charm collar extra-letter fee. Config comes from snippets/collar-extra-letters.liquid.
   After every cart change, sets the add-on quantity to the number of letters listed in the
   "Extra letters" property (repeated letters in the name) of every collar in the cart. */
(function () {
  var cfg = window.fpExtraLetters;
  if (!cfg || !cfg.variants || !cfg.variants.length) return;

  var EXTRA_KEY = 'Extra letters';
  var SOURCE = 'fp-extra-letters';
  var single = cfg.variants.length === 1;
  var byLetters = {};
  var maxCovered = 0;
  cfg.variants.forEach(function (v) {
    byLetters[v.letters] = v;
    if (v.letters > maxCovered) maxCovered = v.letters;
  });

  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';
  var updateUrl = routes.cart_update_url || '/cart/update';

  function extraFor(letters) {
    return String(letters || '').replace(/[^A-Za-z]/g, '').length;
  }

  function wanted(cart) {
    var want = {};
    cfg.variants.forEach(function (v) { want[v.id] = 0; });
    cart.items.forEach(function (item) {
      if (item.product_id === cfg.productId) return;
      var n = extraFor(item.properties && item.properties[EXTRA_KEY]);
      if (!n) return;
      if (single) {
        want[cfg.variants[0].id] += n * item.quantity;
        return;
      }
      var v = byLetters[Math.min(n, maxCovered)];
      if (v) want[v.id] += item.quantity;
      else console.warn('[extra letters] no add-on variant for', n, 'letters');
    });
    return want;
  }

  function have(cart) {
    var got = {};
    cart.items.forEach(function (item) {
      if (item.product_id === cfg.productId) got[item.variant_id] = (got[item.variant_id] || 0) + item.quantity;
    });
    return got;
  }

  function refresh(cart) {
    // The cart page only re-renders its line items on cart updates, not the totals.
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
      return;
    }
    fetch(cartUrl + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        var html = sections && sections['cart-icon-bubble'];
        if (!bubble || !html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: cart });
    }
  }

  var running = null;
  var again = false;

  function sync() {
    if (running) {
      again = true;
      return running;
    }
    running = fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = wanted(cart);
        var got = have(cart);
        var updates = {};
        var changed = false;
        Object.keys(want).forEach(function (id) {
          if ((got[id] || 0) !== want[id]) {
            updates[id] = want[id];
            changed = true;
          }
        });
        if (!changed) return;
        return fetch(updateUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(refresh);
      })
      .catch(function (e) { console.error('[extra letters]', e); })
      .finally(function () {
        running = null;
        if (again) {
          again = false;
          sync();
        }
      });
    return running;
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== SOURCE) sync();
    });
  }
  if (cfg.syncOnLoad) sync();
})();
